module.exports = __webpack_public_path__ + "components/flag/static/square/ir-e9e33a0ebd57f4cafbfa39e2cd7651c1.svg";